/*
 * @Author: your name
 * @Date: 2020-07-23 17:57:49
 * @LastEditTime: 2021-04-07 19:38:36
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\lib\ui\index.js
 */
import { version } from '../../../package.json'
import XSvgIcon from './components/x-svg-icon';
import XInputSearch from './components/x-input-search';
import XInput from './components/x-input';
import XInputMoney from './components/x-input-money';
import XInputPhone from './components/x-input-phone';
import XUpload from './components/x-upload';
import XEmpty from './components/x-empty';
import XModal from './components/x-modal';
import XPersonAvatar from './components/x-person-avatar';
import XTag from './components/x-tag'
import XTagGroup from './components/x-tag-group'
import XNumberInput from './components/x-number-input'
import XColorTag from './components/x-color-tag'
import XUserTag from './components/x-user-tag';
import XLoading from './components/x-loading'
import XArea from './components/x-area';
import XCommentInput from './components/x-comment-inpit/x-comment-input'

import FormMoneyInput from './components/form/form-money-input';
import FormEmailInput from './components/form/form-email-input';
import FormHyperlinkInput from './components/form/form-hyperlink-input'
import FormPhoneInput from './components/form/form-phone-input';
import FormIdcardInput from './components/form/form-id-card-input';
import FormDocumentNumber from './components/form/form-document-number';
import FormUpload from './components/form/form-upload';
import FormTextInput from './components/form/form-text-input'
import FormNumberInput from './components/form/form-number-input'
import FormDateSelect from './components/form/form-date-select'
import FormValueRadio from './components/form/form-value-radio'
import FormTextareaInput from './components/form/form-textarea-input'
import FormValueCheckbox from './components/form/form-value-checkbox'
import FormValueSelect from './components/form/form-value-select'
import FormStaticText from './components/form/form-static-text'
import FormStaticImg from './components/form/form-static-img'
import FormWidgetSplit from './components/form/form-widget-split'
import FormRichText from './components/form/form-rich-text'
import FormDepartmentSelect from './components/form/form-department-select'
import FormPeopleSelect from './components/form/form-people-select';
import FormAssiciated from './components/form/form-associated'
import FormBuildRender from './components/form/form-build-render';
import XProxyFormItem from './components/x-proxy-form-item';
import FormListCard from './components/form/form-list-card'
import FormWidgetTable from './components/form/form-widget-table';
import FormWidgetCalc from './components/form/form-widget-calc';
import FormWidgetLov from './components/form/form-lov';
import FormWidgetLocation from './components/form/form-widget-location'
import FormWidgetArea from './components/form/form-widget-area'
import FormDataStatistics from './components/form/form-data-statistics'
import FormOrcInput from './components/form/form-ocr-input'
import FormOtherTableField from './components/form/form-other-table-field'

import XDateFormatPlugin from './plugins/dayjs/x-date-format';
import XLodashPlugin from './plugins/lodash/x-lodash';
import XStoragePlugin from './plugins/storage/x-storage';
import XEventbusPlugin from './plugins/eventbus/x-eventbus';
import XBomeventPluign from './plugins/bomevent/x-bomevent';
import XRequestPlugin from './plugins/request/x-request';

import XEventOutsideDirective from './directives/x-event-outside/index.js';

const components = [
  XSvgIcon,
  XInput,
  XInputSearch,
  XInputMoney,
  XInputPhone,
  XUpload,
  XEmpty,
  XModal,
  XPersonAvatar,
  XTag,
  XTagGroup,
  XNumberInput,
  XColorTag,
  XUserTag,
  XLoading,
  XArea,
  XCommentInput
]

const formComponents = [
  FormMoneyInput,
  FormEmailInput,
  FormPhoneInput,
  FormIdcardInput,
  FormDocumentNumber,
  FormUpload,
  FormTextInput,
  FormNumberInput,
  FormDateSelect,
  FormValueRadio,
  FormTextareaInput,
  FormValueCheckbox,
  FormValueSelect,
  FormRichText,
  FormStaticText,
  FormStaticImg,
  FormWidgetSplit,
  FormDepartmentSelect,
  FormPeopleSelect,
  FormAssiciated,
  FormBuildRender,
  XProxyFormItem,
  FormListCard,
  FormWidgetTable,
  FormWidgetCalc,
  FormWidgetLov,
  FormWidgetLocation,
  FormWidgetArea,
  FormDataStatistics,
  FormOrcInput,
  FormOtherTableField,
  FormHyperlinkInput
]

const plugins = [
  XRequestPlugin,
  XLodashPlugin,
  XStoragePlugin,
  XEventbusPlugin,
  XBomeventPluign,
  XDateFormatPlugin
]

const allComps = [
  ...components,
  ...formComponents
]

const install = (Vue) => {
  // 判断是否安装
  if (install.installed) {
    return
  }
  plugins.forEach((plugin) => {
    Vue.use(plugin)
  })

  allComps.forEach((component) => {
    Vue.use(component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version,
  install,
  XSvgIcon,
  XInput,
  XInputSearch,
  XDateFormatPlugin,
  XLodashPlugin,
  XStoragePlugin,
  XEventbusPlugin,
  XBomeventPluign,
  XRequestPlugin,
  XEventOutsideDirective
}

export {
  XRequestPlugin,
  XEventbusPlugin,
  XStoragePlugin,
  XLodashPlugin,
  XEventOutsideDirective
}
